/*=========================================================================================
  File Name: moduleCalendarState.js
  Description: Calendar Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  /*users: [],
  classes: [],*/
  candidats: [],
  formateurs: [],
  salaire_formateur: [],
  formations: [],
  domaines: [],
  gains: [],
  participations: [],
  participationsFormations: [],
  participationsDomaines: [],
  GainsFormations: [],
  GainsDomaines: [],
  GainsanneeFormations: [],
  classes_f_s: [],
  domaines_f_s: [],
  formations_f_s: [],
}
